import { useEffect } from 'react';
import { ProcessingOverlay } from 'common/components/UI/ProcessingOverlay';
import { OAuthConfig } from 'common/types/api';
import { Api } from 'common/utils/api';
import FHIR from 'fhirclient';
import { useSearchParams } from 'react-router-dom';

// SMART on FHIR launch endpoint (Epic EHR Launch SSO)
export const SmartLaunch = () => {
    const [searchParams] = useSearchParams();
    const iss = searchParams.get('iss')?.toLowerCase() ?? '';

    useEffect(() => {
        const fetchOAuthConfig = async () => {
            const body = { iss };
            return await Api.post<OAuthConfig>({ path: '/epic/oauth-frontend-config', body });

            // TODO: Handle case when orgId is 'unrecognized', indicating an unfamiliar ISS value
        };

        fetchOAuthConfig().then(config =>
            FHIR.oauth2.authorize({
                clientId: config.clientId,
                scope: 'openid fhirUser launch launch/encounter launch/patient',
                redirectUri: `smart-launch-handler/${config.redirectPath}`,
            })
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <ProcessingOverlay enabled caption="Launching..." />;
};
